import Vue from "vue";
import NewsLetterSubscription from "./NewsLetterSubscription.vue";

export function load() {
  const selector = "news-letter-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(NewsLetterSubscription, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
